import React from "react";
import { ProductFeatureBanner as ProductFeatureBannerComponent } from "~components";

const ProductFeatureBanner = ({ data }) => (
  <article>
    <ProductFeatureBannerComponent {...data} />
  </article>
);

export default ProductFeatureBanner;
